import * as actionTypes from "../../../Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const GetPasswordCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PASSWORD_CRITERIA_RESPONSE:
      return {
        ...state,
        success: action.success.data,
        error: "",
      };
    case actionTypes.GET_PASSWORD_CRITERIA_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default GetPasswordCriteriaReducer;
